import api from "../../lib/api";
import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "../ui/table";
import { Loader } from "../layout/Loader";

const ShipmentTracker = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const [shipmentDetails, setShipmentDetails] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getShipmentDetails = useCallback(async () => {
    if (!orderId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await api.getShipmentDetails(orderId as string);
      if (response?.data?.results?.html) {
        window.location.assign(response?.data?.results?.html);
      } else {
        setShipmentDetails(response?.data?.results?.data || null);
      }
    } catch (err: any) {
      setError("Failed to fetch shipment details");
    } finally {
      setLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    getShipmentDetails();
  }, [getShipmentDetails]);

  return (
    <div className="w-full mt-4 bg-white dark:bg-gray-900 rounded-md p-6 shadow-md">
      <h2 className="text-xl font-semibold mb-4 dark:text-white">
        Shipment Tracking Details - Order ID: {orderId}
      </h2>
      {loading ? (
        <div className="flex justify-center items-center h-32">
          <Loader />
        </div>
      ) : error ? (
        <div className="text-red-500 text-center">{error}</div>
      ) : shipmentDetails && shipmentDetails.ShipmentLogDetails.length > 0 ? (
        <>
          <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <span className="font-medium text-gray-700 dark:text-gray-300">
                AWB No.:
              </span>{" "}
              {shipmentDetails["AWB No."]}
            </div>
            <div>
              <span className="font-medium text-gray-700 dark:text-gray-300">
                Invoice No.:
              </span>{" "}
              {shipmentDetails["Invoice No."]}
            </div>
            <div>
              <span className="font-medium text-gray-700 dark:text-gray-300">
                Transport Partner:
              </span>{" "}
              {shipmentDetails["Transport Partner"]}
            </div>
          </div>
          <div className="rounded-md border dark:border-gray-700 overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="dark:bg-gray-800">
                  {Object.keys(shipmentDetails.ShipmentLogDetails[0]).map(
                    key => (
                      <TableHead key={key} className="dark:text-gray-400">
                        {key}
                      </TableHead>
                    ),
                  )}
                </TableRow>
              </TableHeader>
              <TableBody>
                {shipmentDetails.ShipmentLogDetails &&
                shipmentDetails.ShipmentLogDetails.length > 0 ? (
                  shipmentDetails.ShipmentLogDetails.map((log: any) => (
                    <TableRow
                      key={log.ShipmentStatus + log.ShipmentStatusDateTime}
                      className="dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      {Object.keys(log).map(key => (
                        <TableCell key={key} className="dark:text-gray-300">
                          {log[key]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      className="text-center text-gray-500 dark:text-gray-400"
                    >
                      No shipment tracking details found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </>
      ) : (
        <div className="text-gray-500 text-center">
          No shipment details available.
        </div>
      )}
    </div>
  );
};

export default ShipmentTracker;
